module.exports = __webpack_public_path__ + "media/images/hero-home-90b6eff383dd9a2aa7e998565fc542a6.png";